import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
